import React, { Fragment } from 'react'
import { MainButtonWithSave } from '@newageerp/v3.bundles.buttons-bundle';
import { useListTableRow } from '@newageerp/v3.bundles.app-bundle';

interface Props {
    fieldKey: string,
}

export default function PaymentRefundRequestStatusChange(props: Props) {
    const { element } = useListTableRow();

    if (element.status !== 0) {
        return <Fragment/>
    }

    return (
        <div className='flex gap-2'>
            <MainButtonWithSave
                elementId={element.id}
                saveData={{
                    status: 10
                }}
                schema={"payment-refund-request"}
                color='teal'
                confirmation={true}
            >
                Confirm
            </MainButtonWithSave>

            <MainButtonWithSave
                elementId={element.id}
                saveData={{
                    status: 20
                }}
                schema={"payment-refund-request"}
                color='pink'
                confirmation={true}
            >
                Decline
            </MainButtonWithSave>
        </div>
    )
}
